import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye } from 'lucide-react';
import { useHelpConnect } from './HelpConnectAuth';
import { setHcToken } from './api';
import { HC_VIEW_RETURN_KEY } from '../components/HelpConnectViewPortalButton';

export const HcViewAsBanner = () => {
  const { me } = useHelpConnect();
  const navigate = useNavigate();
  if (!me?.viewed_by) return null;
  const exit = () => {
    const back = sessionStorage.getItem(HC_VIEW_RETURN_KEY) || '/dashboard';
    sessionStorage.removeItem(HC_VIEW_RETURN_KEY);
    setHcToken(null);
    navigate(back);
  };
  return (
    <div className="sticky top-0 z-[60] flex items-center justify-between gap-3 bg-[#922A8C] text-white px-4 py-2 text-sm" data-testid="hc-view-as-banner">
      <span className="flex items-center gap-2"><Eye className="w-4 h-4" />You are viewing as <b>{`${me.first_name || ''} ${me.last_name || ''}`.trim()}</b></span>
      <button onClick={exit} className="rounded-md bg-white text-[#922A8C] font-semibold px-3 py-1 hover:bg-white/90" data-testid="hc-view-as-exit-btn">Exit</button>
    </div>
  );
};
